import React from 'react'
import { useTranslation } from 'react-i18next'

import { BaseModalType } from '@context/ModalsContext'

import { Modal } from '@ui/components/Modal'

import { useWindowResize } from '@utils/domUtils'

import { Box } from '@shared/components/Box'

export type ProductServiceData = {
  name?: string
  imageUrl?: string
  imageUrlMobile?: string
  description?: React.ReactNode
  url?: string
  removed?: boolean
}

interface Props {
  data?: ProductServiceData
}

export const ProductServiceModal: BaseModalType<Props> = (props) => {
  const { t } = useTranslation()
  const { data, close } = props
  const isMobile = useWindowResize()

  if (!data?.name) return null

  const imageSrc = isMobile ? data.imageUrlMobile || data.imageUrl : data.imageUrl

  const handlePrimary = () => {
    if (data?.url) {
      window.open(data.url)
    }
    close()
  }

  if (isMobile) {
    return (
      <Modal>
        <Modal.Header>{data.name}</Modal.Header>
        <Modal.Body>
          <Box fullWidth flex align='center' justify='center'>
            <img
              src={imageSrc}
              loading='eager'
              onLoad={() => window.dispatchEvent(new Event('resize'))}
              alt={data.name}
              style={{ height: '150px', width: '100%', display: 'block', objectFit: 'contain' }}
            />
          </Box>
          {data.description ? <Modal.Body.Text>{data.description}</Modal.Body.Text> : null}
        </Modal.Body>
        <Modal.Footer>
          <Modal.Footer.Secondary onClick={close}>{t('Close')}</Modal.Footer.Secondary>
          <Modal.Footer.Primary onClick={handlePrimary}>
            {t('Platform Vendors.action')}
          </Modal.Footer.Primary>
        </Modal.Footer>
      </Modal>
    )
  }

  return (
    <Modal size='xl'>
      <Modal.Grid.Row>
        <Modal.Grid.Column>
          <Modal.Body>
            <Box flex fullHeight fullWidth p='x24' align='center' justify='center'>
              <img
                src={imageSrc}
                loading={'eager'}
                alt={data.name}
                style={{ width: '100%', display: 'block' }}
              />
            </Box>
          </Modal.Body>
        </Modal.Grid.Column>
        <Modal.Grid.Column>
          <Modal.Header>{data.name}</Modal.Header>
          <Modal.Body>
            {data.description ? <Modal.Body.Text>{data.description}</Modal.Body.Text> : null}
          </Modal.Body>
          <Modal.Footer>
            <Modal.Footer.Secondary onClick={close}>{t('Close')}</Modal.Footer.Secondary>
            <Modal.Footer.Primary onClick={handlePrimary}>
              {t('Platform Vendors.action')}
            </Modal.Footer.Primary>
          </Modal.Footer>
        </Modal.Grid.Column>
      </Modal.Grid.Row>
    </Modal>
  )
}
